import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { whatsappLink } from "../content/site";

const WhatsAppIcon = ({ className = "w-7 h-7" }) => (
  <svg viewBox="0 0 32 32" fill="currentColor" className={className} aria-hidden="true">
    <path d="M16.04 2c-7.73 0-14 6.27-14 14 0 2.47.65 4.88 1.87 7L2 30l7.18-1.88c2.06 1.12 4.37 1.71 6.86 1.71 7.73 0 14-6.27 14-14s-6.27-14-14-14zm0 25.6c-2.14 0-4.24-.58-6.07-1.66l-.44-.26-4.26 1.12 1.14-4.15-.29-.45a11.55 11.55 0 0 1-1.78-6.2c0-6.42 5.22-11.64 11.7-11.64 6.42 0 11.64 5.22 11.64 11.64.06 6.42-5.22 11.6-11.64 11.6zm6.4-8.72c-.35-.18-2.07-1.02-2.4-1.14-.32-.12-.56-.18-.8.18-.23.35-.91 1.14-1.12 1.37-.2.24-.41.27-.76.09-.35-.18-1.48-.55-2.82-1.74-1.04-.93-1.75-2.08-1.95-2.43-.21-.35-.02-.54.15-.72.16-.16.35-.41.53-.61.17-.21.23-.35.35-.58.11-.24.05-.44-.03-.62-.09-.18-.8-1.92-1.09-2.63-.29-.69-.58-.6-.8-.61h-.68c-.24 0-.62.09-.94.44-.32.35-1.24 1.21-1.24 2.96 0 1.74 1.27 3.43 1.45 3.67.17.23 2.5 3.82 6.06 5.35.85.37 1.51.59 2.03.75.85.27 1.63.23 2.24.14.68-.1 2.07-.85 2.37-1.66.29-.82.29-1.52.2-1.66-.08-.15-.32-.24-.67-.42z" />
  </svg>
);

export const WhatsAppFloat = () => {
  const [bubble, setBubble] = useState(0);

  useEffect(() => {
    const t1 = setTimeout(() => setBubble(1), 2200);
    const t2 = setTimeout(() => setBubble(2), 7200);
    const t3 = setTimeout(() => setBubble(0), 14000);
    return () => [t1, t2, t3].forEach(clearTimeout);
  }, []);

  return (
    <div className="fixed right-5 sm:right-7 bottom-20 sm:bottom-24 z-[90] flex flex-col items-end gap-3">
      <AnimatePresence mode="wait">
        {bubble > 0 && (
          <motion.button
            key={bubble}
            data-testid="whatsapp-tooltip-bubble"
            onClick={() => setBubble(0)}
            initial={{ opacity: 0, y: 8, scale: 0.92 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 6, scale: 0.95 }}
            transition={{ duration: 0.35, ease: "easeOut" }}
            className="glass rounded-2xl rounded-br-md px-4 py-2.5 text-sm text-slate-800 shadow-xl cursor-pointer max-w-[220px] text-left"
          >
            {bubble === 1 ? "Need help with your website? 👋" : "Chat with WebStudios on WhatsApp"}
          </motion.button>
        )}
      </AnimatePresence>
      <motion.a
        data-testid="whatsapp-float-button"
        href={whatsappLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with WebStudios on WhatsApp"
        title="Chat with us on WhatsApp"
        className="relative flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 rounded-full text-white"
        style={{ background: "#25D366", boxShadow: "0 6px 30px rgba(37, 211, 102, 0.45)" }}
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ delay: 1.2, type: "spring", stiffness: 260, damping: 18 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.94 }}
      >
        <span className="absolute inset-0 rounded-full wa-pulse-ring" style={{ background: "rgba(37,211,102,0.5)" }} aria-hidden="true" />
        <WhatsAppIcon />
      </motion.a>
    </div>
  );
};
